import _ from 'lodash'
import React, { useCallback, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { useRequestHandler } from '@/hooks/useRequestHandler'

import useMediaDevices from '@/hooks/useMediaDevices'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { deleteCustomDevice, getCustomDevices, selectCustomDeviceDeleteRequestState, selectCustomDevices } from '@/redux/reducers/custom-device.reducer'

import CustomDevices from '../components/CustomDevices'

type CustomDevicesContainerProps = {}

export default function CustomDevicesContainer(props: CustomDevicesContainerProps) {
  const appDispatch = useAppDispatch()
  const mediaDevices = useMediaDevices()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  const customDevices = useAppSelector(selectCustomDevices)

  const customDevicesWithAvailableStatus = useMemo(() => {
    return _.map(customDevices, (customDevice) => {
      const device = _.find(mediaDevices, (mediaDevice) => mediaDevice.label === customDevice.device.name)
      return _.merge({}, customDevice, { available: !!device, device })
    })
  }, [customDevices, mediaDevices])

  const { dispatch: customDeviceDeleteRequestDispatch, requestTracker: customDeviceDeleteRequestTracker } = useRequestHandler({
    onSuccess: () => enqueueSnackbar(t('notification.customDevice.delete.success'), { variant: 'success' }),
    onError: () => enqueueSnackbar(t('notification.customDevice.delete.error'), { variant: 'error' }),
    requestTrackerSelector: selectCustomDeviceDeleteRequestState,
  })

  const handleDelete = useCallback(
    (id: string) => {
      customDeviceDeleteRequestDispatch(deleteCustomDevice(id))
    },
    [customDeviceDeleteRequestDispatch]
  )

  useEffect(() => {
    appDispatch(getCustomDevices())
  }, [appDispatch])

  return (
    <CustomDevices customDevices={customDevicesWithAvailableStatus} isDeleting={customDeviceDeleteRequestTracker.loading} onDeleteCustomDevice={handleDelete} />
  )
}
